var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlphabeticalDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    width: 100,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.444 78c-.212 0-.424-.036-.636-.1-1.052-.352-1.604-1.492-1.252-2.532l18.868-56c.268-.82 1.028-1.368 1.892-1.368.86 0 1.62.556 1.896 1.368l18.868 56c.352 1.052-.212 2.18-1.256 2.532-1.048.36-2.18-.216-2.532-1.252L71.32 26.272 54.348 76.644C54.064 77.472 53.28 78 52.444 78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.244 58h28v4h-28v-4zm-12 20H5.816c-.744 0-1.424-.416-1.768-1.072s-.3-1.448.12-2.072l36.28-52.868H12.244c-1.104 0-2-.9-2-2s.896-2 2-2h32c.744 0 1.424.416 1.768 1.072.344.664.3 1.448-.12 2.072L9.612 74h34.632c1.104 0 2 .9 2 2s-.896 2-2 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.244 46h-16c-1.104 0-2-.9-2-2s.896-2 2-2h16c1.104 0 2 .9 2 2s-.896 2-2 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.244 55.752c-.444 0-.896-.148-1.268-.444-.852-.704-.976-1.96-.276-2.816l6.96-8.48-6.96-8.48c-.7-.86-.58-2.112.276-2.82.856-.696 2.112-.58 2.816.272l8 9.752c.604.748.604 1.8 0 2.54l-8 9.752c-.396.472-.972.724-1.548.724z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabeticalDesc);
export default __webpack_public_path__ + "static/media/alphabetical-desc.e46b4d6283a9faa4fd7728a639d61d70.svg";
export { ForwardRef as ReactComponent };